import { trackMixpanelRoute } from '@/plugins/mixpanel'
import { trackNewRelicRoute } from '@/plugins/newrelic'

export function registerAnalyticsRouteTracking(router) {
  router.afterEach((to, from) => {
    try {
      trackMixpanelRoute(to, from)
    } catch (e) {
      // fail silently — Mixpanel error must not block New Relic tracking
    }
    try {
      trackNewRelicRoute(to, from)
    } catch (e) {
      // fail silently — New Relic error must not block Mixpanel tracking
    }
  })
}
